export const GET_ALL_CITY_BEGIN = "GET_ALL_CITY_BEGIN"
export const GET_ALL_CITY_SUCCESS = "GET_ALL_CITY_SUCCESS"
export const GET_ALL_CITY_ERROR = "GET_ALL_CITY_ERROR"

export const ADD_CITY_BEGIN = "ADD_CITY_BEGIN"
export const ADD_CITY_SUCCESS = "ADD_CITY_SUCCESS"
export const ADD_CITY_ERROR = "ADD_CITY_ERROR"

export const GET_CITY_BEGIN = "GET_CITY_BEGIN"
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS"
export const GET_CITY_ERROR = "GET_CITY_ERROR"

export const UPDATE_CITY_BEGIN = "UPDATE_CITY_BEGIN"
export const UPDATE_CITY_SUCCESS = "UPDATE_CITY_SUCCESS"
export const UPDATE_CITY_ERROR = "UPDATE_CITY_ERROR"

export const DELETE_CITY_BEGIN = "DELETE_CITY_BEGIN"
export const DELETE_CITY_SUCCESS = "DELETE_CITY_SUCCESS"
export const DELETE_CITY_ERROR = "DELETE_CITY_ERROR"